var _circle, _path, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUrgentIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 16.2858,
    r: 0.714286,
    fill: "#EE2D24"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7143 9.5C12.7143 13.5476 12 14.1429 12 14.1429C12 14.1429 11.2857 13.5476 11.2857 9.5C11.2857 7 11.6055 7 12 7C12.3945 7 12.7143 7 12.7143 9.5Z",
    fill: "#EE2D24"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8.5,
    stroke: "#EE2D24"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUrgentIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/urgent-icon.92820241.svg";
export { ForwardRef as ReactComponent };